<div class="text-dialog">
  @if (data.title) {
  <h2
    mat-dialog-title
    [ngStyle]="data.centeredTitle && { 'text-align': 'center' }"
  >
    {{ data.title }}
  </h2>
  }

  <mat-dialog-content cdkFocusInitial>
    @if (data.text) {
    <p
      [class.big-text]="!data.title"
      [ngStyle]="data.centeredText && { 'text-align': 'center' }"
    >
      {{ data.text }}
    </p>
    } @if (data.htmlText) {
    <div
      [class.big-text]="!data.title"
      [ngStyle]="data.centeredText && { 'text-align': 'center' }"
      [innerHTML]="data.htmlText"
    ></div>
    } @if (data.subText) {
    <p>{{ data.subText }}</p>
    } @if (data.usersToRedirect) { @for (user of data.usersToRedirect; track
    user) {
    <profile-ingot class="mb-1">
      <ng-container image>
        <file-jet-img
          [image]="user.avatar"
          [width]="40"
          [height]="40"
        ></file-jet-img>
      </ng-container>
      <a (click)="onLinkClick(user.id)">{{ user | userName }}</a>
      <span>{{ user.job_title }}</span>
    </profile-ingot>
    } }
  </mat-dialog-content>
  <div class="d-flex justify-content-center">
    @if (data.checkboxText) {
    <input
      id="confirmation-checkbox"
      [(ngModel)]="confirmCheckbox"
      type="checkbox"
      class="checkbox pull-left styled-checkbox"
    />
    }
    <label class="pull-left ms-2 mb-0" for="confirmation-checkbox">{{
      data.checkboxText
    }}</label>
  </div>
  <mat-dialog-actions class="buttons" [class.centered]="data.centeredBtns">
    <button
      mat-button
      class="btn btn-default"
      tabindex="-1"
      (click)="dialogRef.close('cancel')"
    >
      {{ data.cancelBtnText ? data.cancelBtnText : 'Close' }}
    </button>
    @if (data.submitBtnText) {
    <button
      mat-button
      class="btn btn-default"
      tabindex="-1"
      [disabled]="data.checkboxText && !confirmCheckbox"
      (click)="dialogRef.close('submit')"
    >
      {{ data.submitBtnText }}
    </button>
    }
  </mat-dialog-actions>
</div>
